export default __webpack_public_path__ + "static/media/account-opening.1f2e554e.svg";